import ApiService from "@/services/ApiService";

export default {
  path: "orders",

  orders(payload) {
    return ApiService.axios.post(`/${this.path}`, payload);
  }
};
